import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design-components/base/eco-img';
import EcoSpace from 'eco-design-components/base/eco-space';
import { useState, useEffect, MouseEvent, useRef, useMemo } from 'react';
import css from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { Swiper as SwiperType } from 'swiper/types';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import EcoLink from 'eco-design/base/eco-link';
import { Amazon } from './icons';
import EfSection from '@elem/ui/ef-section';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import gtm from 'eco-design-reliance/gtm';
import useProductInfo from '@/utils/hooks/useProductInfo';
import { useProductDispatch, useProductStore } from '../../../../ProductProvider';
import { IPageStatus } from '../../../../config/IPageStatus';
import { getIsMobileWidth, getIsPadWidth } from '@elem/utils/devices';
import Dialog from './Dialog';

interface ItemType {
    imgs?: string[];
    childrenColor?: string[];
    children?: object[];
    img: string;
    title: string;
    index: number;
    productId?: string;
    variantId?: string;
    price: number;
    compareAtPrice: number;
    inventoryQuantity: number;
    inventoryPolicy?: 'deny' | 'continue' | undefined;
    btnType?: 'buy' | 'cart' | 'more';
    linkMore?: string;
    linkBuy?: string;
    linkBuyUs?: string;
    linkAmazon?: string;
    isNotifyMe?: boolean;
    isComingSoon?: string;
    info: {
        title: string;
        desc: string;
    }[];
}

const C: React.FC = () => {
    const { locale = 'us' } = useRouter();
    const dispatch = useProductDispatch();
    const { t } = useLang('powerBank.C');
    const IS_EU: boolean = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);
    const IS_US: boolean = ['us', 'ca'].includes(locale);
    const IS_PH: boolean = ['ph'].includes(locale);
    const isMobile = getIsMobileWidth() || false; //是否是移动端
    const [showNotifyMeModal, setShowNotifyMeModal] = useState(false);
    const [swiperInstance, setSwiperInstance] = useState<SwiperType>();
    const [isPad, setIsPad] = useState(false);
    useEffect(() => {
        const checkPadWidth = () => {
            if (typeof document !== 'undefined') {
                const width = document.documentElement.clientWidth;
                if (width < 1024) {
                    setIsPad(true);
                }
            }
        };
        checkPadWidth();
        window.addEventListener('resize', checkPadWidth);
        return () => window.removeEventListener('resize', checkPadWidth);
    }, []);
    let data: ItemType[] = [
        {
            img: '',
            imgs: [
                'https://websiteoss.ecoflow.com/upload/image/1748687312112/EcoFlow%20STREAM.png',
                'https://websiteoss.ecoflow.com/upload/image/1748687310266/EcoFlow%20STREAM%20(1).png',
                'https://websiteoss.ecoflow.com/upload/image/1748687312992/EcoFlow%20STREAM%20(2).png',
            ],
            title: t('C_item1_title'),
            index: 0,

            price: 0,
            compareAtPrice: 0,
            inventoryQuantity: 0,

            linkBuy: `https://${locale}.ecoflow.com/products/rapid-power-bank-25000mah-170w-100w-usb-c`,

            info: [
                { title: t('C_item1_info3_title'), desc: t('C_item1_info3_desc') },
                { title: t('C_item1_info1_title'), desc: t('C_item1_info1_desc') },
                { title: t('C_item1_info2_title'), desc: t('C_item1_info2_desc') },
            ],
            childrenColor: ['#959DA5', '#2C2C2C', '#50665F'],
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748687312112/EcoFlow%20STREAM.png',

                    productId: '14718140186991',
                    variantId: '52003115827567', //银
                    lBtn: t('buy2'),
                    color: '#959DA5',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FCXQ5FCD',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748687310266/EcoFlow%20STREAM%20(1).png',

                    productId: '14718140186991',
                    variantId: '52003115893103', //黑
                    color: '#2C2C2C',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FCY62WHX',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748687312992/EcoFlow%20STREAM%20(2).png',

                    productId: '14718140186991',
                    variantId: '52003115860335', //绿
                    color: '#50665F',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FCXFC33Z',
                },
            ],
        },
        {
            img: '',
            imgs: [
                'https://websiteoss.ecoflow.com/upload/image/1748687311715/EcoFlow%20STREAM%20(5).png',
                'https://websiteoss.ecoflow.com/upload/image/1748687312637/EcoFlow%20STREAM%20(4).png',
                'https://websiteoss.ecoflow.com/upload/image/1748687311510/EcoFlow%20STREAM%20(3).png',
            ],
            title: t('C_item2_title'),
            index: 1,

            price: 0,
            compareAtPrice: 0,
            inventoryQuantity: 0,

            linkBuy: `https://${locale}.ecoflow.com/products/rapid-power-bank-25000mah-170w`,
            linkAmazon: 'www.google.com',
            info: [
                { title: t('C_item2_info1_title'), desc: t('C_item2_info1_desc') },
                { title: t('C_item2_info3_title'), desc: t('C_item2_info3_desc') },
                { title: t('C_item2_info2_title'), desc: t('C_item2_info2_desc') },
            ],
            childrenColor: ['#959DA5', '#2C2C2C', '#50665F'],
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748687311715/EcoFlow%20STREAM%20(5).png',
                    productId: '14718152868207',
                    variantId: '52003246375279', //银
                    lBtn: t('buy2'),
                    color: '#959DA5',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FCXVLQK6',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748687312637/EcoFlow%20STREAM%20(4).png',
                    productId: '14718152868207',
                    variantId: '52003246309743', //黑
                    color: '#2C2C2C',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FCX18F4V',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748687311510/EcoFlow%20STREAM%20(3).png',
                    productId: '14718152868207',
                    variantId: '52003246342511', //绿
                    color: '#50665F',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FCXKRNYZ',
                },
            ],
        },
        {
            img: '',
            imgs: [
                'https://websiteoss.ecoflow.com/upload/image/1749631559671/rapid%2010k%203-in-1.png',
                'https://websiteoss.ecoflow.com/upload/image/1749631559890/rapid%2010k%203-in-1%20(1).png',
                'https://websiteoss.ecoflow.com/upload/image/1749631560103/rapid%2010k%203-in-1%20(2).png',
            ],
            title: t('C_item3_title'),
            index: 2,

            price: 0,
            compareAtPrice: 0,
            inventoryQuantity: 0,
            linkBuy: `https://${locale}.ecoflow.com/products/rapid-3-in-1-power-bank-10000mah-35w`,
            linkAmazon: 'www.google.com',
            info: [
                { title: t('C_item3_info1_title'), desc: t('C_item3_info1_desc') },
                { title: t('C_item3_info2_title'), desc: t('C_item3_info2_desc') },
                { title: t('C_item3_info3_title'), desc: t('C_item3_info3_desc') },
            ],
            childrenColor: ['#2C2C2C', '#FFFFFF', '#B0D2A9'],
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1749631559671/rapid%2010k%203-in-1.png',
                    productId: '14718154244463',
                    variantId: '52003260825967', //黑
                    color: '#2C2C2C',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FD38W8SV',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1749631559890/rapid%2010k%203-in-1%20(1).png',
                    productId: '14718154244463',
                    variantId: '52003260891503', //白
                    lBtn: t('buy2'),
                    color: '#FFFFFF',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FD3BP51P',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1749631560103/rapid%2010k%203-in-1%20(2).png',
                    productId: '14718154244463',
                    variantId: '52003260858735', //绿
                    color: '#B0D2A9',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FD3CSM4T',
                },
            ],
        },
        {
            img: '',
            imgs: [
                'https://websiteoss.ecoflow.com/upload/image/1748687311939/EcoFlow%20STREAM%20(9).png',
                'https://websiteoss.ecoflow.com/upload/image/1748687312283/EcoFlow%20STREAM%20(10).png',
            ],
            title: t('C_item4_title'),
            index: 3,

            price: 0,
            compareAtPrice: 0,
            inventoryQuantity: 0,

            linkBuy: `https://${locale}.ecoflow.com/products/rapid-45w-gan-usb-c`,
            linkAmazon: 'www.google.com',
            info: [
                { title: t('C_item4_info1_title'), desc: t('C_item4_info1_desc') },
                { title: t('C_item4_info2_title'), desc: t('C_item4_info2_desc') },
                { title: t('C_item4_info3_title'), desc: t('C_item4_info3_desc') },
            ],
            // childrenColor: ['#ffffff', '#2C2C2C', '#BCBBE8', '#F6CFAF', '#B0D2A9'],
            childrenColor: ['#ffffff', '#2C2C2C'],
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748687311939/EcoFlow%20STREAM%20(9).png',
                    productId: '14718205198703',
                    variantId: '52003762471279', //白
                    color: '#ffffff',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FCXY2TQ3',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748687312283/EcoFlow%20STREAM%20(10).png',
                    productId: '14718205198703',
                    variantId: '52003762438511', //黑
                    color: '#2C2C2C',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FCY25WGR',
                },
            ],
        },
        {
            img: '',
            imgs: [
                'https://websiteoss.ecoflow.com/upload/image/1748687310408/EcoFlow%20STREAM%20(14).png',
                'https://websiteoss.ecoflow.com/upload/image/1748687310784/EcoFlow%20STREAM%20(15).png',
            ],
            title: t('C_item5_title'),
            index: 4,

            price: 0,
            compareAtPrice: 0,
            inventoryQuantity: 0,

            linkBuy: `https://${locale}.ecoflow.com/products/rapid-65w-gan-usb-c`,
            linkAmazon: 'www.google.com',
            info: [
                { title: t('C_item5_info1_title'), desc: t('C_item5_info1_desc') },
                { title: t('C_item5_info2_title'), desc: t('C_item5_info2_desc') },
                { title: t('C_item5_info3_title'), desc: t('C_item5_info3_desc') },
            ],
            // childrenColor: ['#ffffff', '#2C2C2C', '#BCBBE8', '#F6CFAF', '#B0D2A9'],
            childrenColor: ['#ffffff', '#2C2C2C'],
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748687310408/EcoFlow%20STREAM%20(14).png',
                    productId: '14718207492463',
                    variantId: '52003785998703', //白
                    color: '#ffffff',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FCXYRNR8',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748687310784/EcoFlow%20STREAM%20(15).png',
                    productId: '14718207492463',
                    variantId: '52003785965935', //黑
                    color: '#2C2C2C',
                    linkAmazon: 'https://www.amazon.co.jp/dp/B0FCXVQBHL',
                },

                // {
                //     pc: 'https://websiteoss.ecoflow.com/upload/image/1748687310607/EcoFlow%20STREAM%20(11).png',
                //     productId: '14718207492463',
                //     variantId: '52003786031471', //紫
                //     lDisabled: true,
                //     DisabledText: t('disabledText'),
                //     lBtn: t('buy2'),
                //     color: '#BCBBE8',
                // },
                // {
                //     pc: 'https://websiteoss.ecoflow.com/upload/image/1748687311150/EcoFlow%20STREAM%20(13).png',
                //     productId: '14718207492463',
                //     variantId: '52003786097007', //粉
                //     lDisabled: true,
                //     DisabledText: t('disabledText'),
                //     lBtn: t('buy2'),
                //     color: '#F6CFAF',
                // },
                // {
                //     pc: 'https://websiteoss.ecoflow.com/upload/image/1748687310965/EcoFlow%20STREAM%20(12).png',
                //     productId: '14718207492463',
                //     variantId: '52003786064239', //绿
                //     lDisabled: true,
                //     DisabledText: t('disabledText'),
                //     lBtn: t('buy2'),
                //     color: '#B0D2A9',
                // },
            ],
        },
    ];
    if (IS_EU) {
        data = [
            {
                img: '',
                imgs: [
                    'https://websiteoss.ecoflow.com/upload/image/1748687312112/EcoFlow%20STREAM.png',
                    'https://websiteoss.ecoflow.com/upload/image/1748687310266/EcoFlow%20STREAM%20(1).png',
                ],
                title: t('C_item1_title'),
                index: 0,
                price: 0,
                compareAtPrice: 0,
                inventoryQuantity: 0,
                linkBuy: `https://${locale}.ecoflow.com/products/rapid-power-bank-25k-built-in-and-retractable-cables`,
                linkAmazon: 'www.google.com',
                info: [
                    { title: t('C_item1_info1_title'), desc: t('C_item1_info1_desc') },
                    { title: t('C_item1_info2_title'), desc: t('C_item1_info2_desc') },
                    { title: t('C_item1_info3_title'), desc: t('C_item1_info3_desc') },
                ],
                childrenColor: ['#959DA5', '#2C2C2C'],
                children: [
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687312112/EcoFlow%20STREAM.png',
                        productId: (() => {
                            // 25k 带线银色
                            const localMap: any = {
                                eu: '10057128640855',
                                uk: '9922545779027',
                                de: '15246674329981',
                                fr: '9916300132699',
                                it: '14929760485752',
                                es: '9916311732571',
                                nl: '9935713796372',
                            };
                            return localMap[locale] || undefined;
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                eu: '50740952301911',
                                uk: '51054692991315',
                                de: '56082570543485',
                                fr: '50630581846363',
                                it: '55141748179320',
                                es: '50630613434715',
                                nl: '51194425966868',
                            };
                            return localMap[locale] || undefined;
                        })(),
                        lBtn: t('buy2'),
                        color: '#959DA5',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687310266/EcoFlow%20STREAM%20(1).png',

                        productId: (() => {
                            // 25k 带线黑色
                            const localMap: any = {
                                eu: '10057128640855',
                                uk: '9922545779027',
                                de: '15246674329981',
                                fr: '9916300132699',
                                it: '14929760485752',
                                es: '9916311732571',
                                nl: '9935713796372',
                            };
                            return localMap[locale] || undefined;
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                eu: '50740952269143',
                                uk: '51054692958547',
                                de: '56082570510717',
                                fr: '50630581813595',
                                it: '55141748146552',
                                es: '50630613401947',
                                nl: '51194425934100',
                            };
                            return localMap[locale] || undefined;
                        })(),
                        color: '#2C2C2C',
                    },
                ],
            },
            {
                img: '',
                imgs: [
                    'https://websiteoss.ecoflow.com/upload/image/1748687311715/EcoFlow%20STREAM%20(5).png',
                    'https://websiteoss.ecoflow.com/upload/image/1748687312637/EcoFlow%20STREAM%20(4).png',
                ],
                title: t('C_item2_title'),
                index: 1,
                price: 0,
                compareAtPrice: 0,
                inventoryQuantity: 0,
                linkBuy: `https://${locale}.ecoflow.com/products/rapid-power-bank-25k`,
                linkAmazon: 'www.google.com',
                info: [
                    { title: t('C_item2_info1_title'), desc: t('C_item2_info1_desc') },
                    { title: t('C_item2_info2_title'), desc: t('C_item2_info2_desc') },
                    { title: t('C_item2_info3_title'), desc: t('C_item2_info3_desc') },
                ],
                childrenColor: ['#959DA5', '#2C2C2C'],
                children: [
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687311715/EcoFlow%20STREAM%20(5).png',
                        productId: (() => {
                            // 25k 不带线银色
                            const localMap: any = {
                                eu: '10057129263447',
                                uk: '9922546729299',
                                de: '15246675149181',
                                fr: '9916300362075',
                                it: '14929760584056',
                                es: '9916311961947',
                                nl: '9935713829140',
                            };
                            return localMap[locale] || undefined;
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                eu: '50740958167383',
                                uk: '51048663220563',
                                de: '56082576212349',
                                fr: '50630582862171',
                                it: '55141749064056',
                                es: '50630614679899',
                                nl: '51194425704724',
                            };
                            return localMap[locale] || undefined;
                        })(),
                        lBtn: t('buy2'),
                        color: '#959DA5',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687312637/EcoFlow%20STREAM%20(4).png',

                        productId: (() => {
                            // 25k 不带线黑色
                            const localMap: any = {
                                eu: '10057129263447',
                                uk: '9922546729299',
                                de: '15246675149181',
                                fr: '9916300362075',
                                it: '14929760584056',
                                es: '9916311961947',
                                nl: '9935713829140',
                            };
                            return localMap[locale] || undefined;
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                eu: '50740958134615',
                                uk: '51048663187795',
                                de: '56082576179581',
                                fr: '50630582829403',
                                it: '55141749031288',
                                es: '50630614647131',
                                nl: '51194425671956',
                            };
                            return localMap[locale] || undefined;
                        })(),
                        color: '#2C2C2C',
                    },
                ],
            },
        ];
    }
    if (IS_US) {
        data = [
            {
                img: '',
                imgs: [
                    'https://websiteoss.ecoflow.com/upload/image/1748687312112/EcoFlow%20STREAM.png',
                    'https://websiteoss.ecoflow.com/upload/image/1748687310266/EcoFlow%20STREAM%20(1).png',
                ],
                title: t('C_item1_title'),
                index: 0,

                price: 0,
                compareAtPrice: 0,
                inventoryQuantity: 0,
                linkBuy: (() => {
                    const linkBuyMap: any = {
                        us: `https://${locale}.ecoflow.com/products/ecoflow-rapid-power-bank-25-000mah-170w-100w-built-in-and-retractable`,
                        ca: `https://${locale}.ecoflow.com/products/ecoflow-rapid-power-bank-25-000mah-170w-100w-built-in-and-retractable-cables`,
                    };
                    return linkBuyMap[locale] || undefined;
                })(),

                info: [
                    { title: t('C_item1_info3_title'), desc: t('C_item1_info3_desc') },
                    { title: t('C_item1_info1_title'), desc: t('C_item1_info1_desc') },
                    { title: t('C_item1_info2_title'), desc: t('C_item1_info2_desc') },
                ],
                childrenColor: ['#959DA5', '#2C2C2C'],
                children: [
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687312112/EcoFlow%20STREAM.png',
                        color: '#959DA5',
                        //    银色
                        productId: (() => {
                            const localMap: any = {
                                us: '15361641709641',
                                ca: '15126337028467',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                us: '54593881407561',
                                ca: '52731611021683',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        linkAmazon: (() => {
                            const linkAmazonMap: any = {
                                us: 'https://www.amazon.com/dp/B0FHB6J2ZW?maas=maas_adg_12A89AE2D202D7058E76593334370A38_afap_abs&ref_=aa_maas&tag=maas',
                                ca: 'https://www.amazon.ca/dp/B0FHB6J2ZW?maas=maas_adg_6B102F42FC6E9881E5E7FCD1FA2DB97C_afap_abs&ref_=aa_maas&tag=maas',
                            };
                            return linkAmazonMap[locale] || linkAmazonMap['us'];
                        })(),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687310266/EcoFlow%20STREAM%20(1).png',
                        color: '#2C2C2C',
                        //黑
                        productId: (() => {
                            const localMap: any = {
                                us: '15361641709641',
                                ca: '15126337028467',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                us: '54593881374793',
                                ca: '52731603059059',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        linkAmazon: (() => {
                            const linkAmazonMap: any = {
                                us: 'https://www.amazon.com/dp/B0FHB5WDKL?maas=maas_adg_21EDCE54DA4A5BB8D9C51DA8CAA217B9_afap_abs&ref_=aa_maas&tag=maas',
                                ca: 'https://www.amazon.ca/dp/B0FHB5WDKL?maas=maas_adg_00384F567441A1BC653224EED372D436_afap_abs&ref_=aa_maas&tag=maas',
                            };
                            return linkAmazonMap[locale] || linkAmazonMap['us'];
                        })(),
                    },
                ],
            },
            {
                img: '',
                imgs: [
                    'https://websiteoss.ecoflow.com/upload/image/1748687311715/EcoFlow%20STREAM%20(5).png',
                    'https://websiteoss.ecoflow.com/upload/image/1748687312637/EcoFlow%20STREAM%20(4).png',
                ],
                title: t('C_item2_title'),
                index: 1,

                price: 0,
                compareAtPrice: 0,
                inventoryQuantity: 0,

                linkBuy: (() => {
                    const linkBuyMap: any = {
                        us: `https://${locale}.ecoflow.com/products/ecoflow-rapid-power-bank-25000mah-170w`,
                        ca: `https://${locale}.ecoflow.com/products/ecoflow-rapid-power-bank-25000mah-170w`,
                    };
                    return linkBuyMap[locale] || undefined;
                })(),
                info: [
                    { title: t('C_item2_info1_title'), desc: t('C_item2_info1_desc') },
                    { title: t('C_item2_info3_title'), desc: t('C_item2_info3_desc') },
                    { title: t('C_item2_info2_title'), desc: t('C_item2_info2_desc') },
                ],
                childrenColor: ['#959DA5', '#2C2C2C'],
                children: [
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687311715/EcoFlow%20STREAM%20(5).png',
                        lBtn: t('buy2'),
                        color: '#959DA5',
                        //银
                        productId: (() => {
                            const localMap: any = {
                                us: '15361642627145',
                                ca: '15126359998835',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                us: '54593882161225',
                                ca: '52731627929971',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        linkAmazon: (() => {
                            const linkAmazonMap: any = {
                                us: 'https://www.amazon.com/dp/B0FHPMX7DR?maas=maas_adg_0B946CF7C77D3476E15F1808707AB748_afap_abs&ref_=aa_maas&tag=maas',
                                ca: 'https://www.amazon.ca/dp/B0FHPMX7DR?maas=maas_adg_929F0F50E4D9EB04F3A6DA75A0BF892F_afap_abs&ref_=aa_maas&tag=maas',
                            };
                            return linkAmazonMap[locale] || linkAmazonMap['us'];
                        })(),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687312637/EcoFlow%20STREAM%20(4).png',
                        color: '#2C2C2C',
                        //黑
                        productId: (() => {
                            const localMap: any = {
                                us: '15361642627145',
                                ca: '15126359998835',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                us: '54593882128457',
                                ca: '52731627897203',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        linkAmazon: (() => {
                            const linkAmazonMap: any = {
                                us: 'https://www.amazon.com/dp/B0FHB7CJKT?maas=maas_adg_A8117B0D143E86E6DA1D4072A15E5360_afap_abs&ref_=aa_maas&tag=maas',
                                ca: 'https://www.amazon.ca/dp/B0FHB7CJKT?maas=maas_adg_087ABFAE98FBFDD2D6A1012373188851_afap_abs&ref_=aa_maas&tag=maas',
                            };
                            return linkAmazonMap[locale] || linkAmazonMap['us'];
                        })(),
                    },
                ],
            },
            {
                img: '',
                imgs: [
                    'https://websiteoss.ecoflow.com/upload/image/1748687311939/EcoFlow%20STREAM%20(9).png',
                    'https://websiteoss.ecoflow.com/upload/image/1748687312283/EcoFlow%20STREAM%20(10).png',
                ],
                title: t('C_item3_title'),
                index: 2,

                price: 0,
                compareAtPrice: 0,
                inventoryQuantity: 0,

                linkBuy: (() => {
                    const linkBuyMap: any = {
                        us: `https://${locale}.ecoflow.com/products/ecoflow-rapid-charger-45w-retractable-calble-gan`,
                        ca: `https://${locale}.ecoflow.com/products/ecoflow-rapid-charger-45w-retractable-calble-gan`,
                    };
                    return linkBuyMap[locale] || undefined;
                })(),
                info: [
                    { title: t('C_item3_info1_title'), desc: t('C_item3_info1_desc') },
                    { title: t('C_item3_info2_title'), desc: t('C_item3_info2_desc') },
                    { title: t('C_item3_info3_title'), desc: t('C_item3_info3_desc') },
                ],
                childrenColor: ['#ffffff', '#2C2C2C'],
                children: [
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687311939/EcoFlow%20STREAM%20(9).png',
                        color: '#ffffff',
                        //白
                        productId: (() => {
                            const localMap: any = {
                                us: '15361643708489',
                                ca: '15126369436019',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                us: '54593883603017',
                                ca: '52731644674419',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        linkAmazon: (() => {
                            const linkAmazonMap: any = {
                                us: 'https://www.amazon.com/dp/B0FHBBG6TY?maas=maas_adg_7FA974DFE9715262A64DDCB2CEBB75FE_afap_abs&ref_=aa_maas&tag=maas',
                                ca: 'https://www.amazon.ca/dp/B0FHBBG6TY?maas=maas_adg_7A7EBF338A12F7944EEB6991E9B76BFC_afap_abs&ref_=aa_maas&tag=maas',
                            };
                            return linkAmazonMap[locale] || linkAmazonMap['us'];
                        })(),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687312283/EcoFlow%20STREAM%20(10).png',
                        color: '#2C2C2C',
                        //黑
                        productId: (() => {
                            const localMap: any = {
                                us: '15361643708489',
                                ca: '15126369436019',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                us: '54593883570249',
                                ca: '52731643560307',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        linkAmazon: (() => {
                            const linkAmazonMap: any = {
                                us: 'https://www.amazon.com/dp/B0FHB8BPY2?maas=maas_adg_BB10300739BC0F6034FC66AAED48D8FE_afap_abs&ref_=aa_maas&tag=maas',
                                ca: 'https://www.amazon.ca/dp/B0FHB8BPY2?maas=maas_adg_9B24454CBCEDA548D0375FC1F4DCDD70_afap_abs&ref_=aa_maas&tag=maas',
                            };
                            return linkAmazonMap[locale] || linkAmazonMap['us'];
                        })(),
                    },
                ],
            },
            {
                img: '',
                imgs: [
                    'https://websiteoss.ecoflow.com/upload/image/1748687310408/EcoFlow%20STREAM%20(14).png',
                    'https://websiteoss.ecoflow.com/upload/image/1748687310784/EcoFlow%20STREAM%20(15).png',
                ],
                title: t('C_item4_title'),
                index: 3,
                price: 0,
                compareAtPrice: 0,
                inventoryQuantity: 0,

                linkBuy: (() => {
                    const linkBuyMap: any = {
                        us: `https://${locale}.ecoflow.com/products/ecoflow-rapid-charger-65w-retractable-calble-gan`,
                        ca: `https://${locale}.ecoflow.com/products/ecoflow-rapid-charger-65w-retractable-calble-gan`,
                    };
                    return linkBuyMap[locale] || undefined;
                })(),
                info: [
                    { title: t('C_item4_info1_title'), desc: t('C_item4_info1_desc') },
                    { title: t('C_item4_info2_title'), desc: t('C_item4_info2_desc') },
                    { title: t('C_item4_info3_title'), desc: t('C_item4_info3_desc') },
                ],
                childrenColor: ['#ffffff', '#2C2C2C'],
                children: [
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687310408/EcoFlow%20STREAM%20(14).png',
                        color: '#ffffff',
                        //白
                        productId: (() => {
                            const localMap: any = {
                                us: '15361644200009',
                                ca: '15126373794163',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                us: '54593884192841',
                                ca: '52731645067635',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        linkAmazon: (() => {
                            const linkAmazonMap: any = {
                                us: 'https://www.amazon.com/dp/B0FG89JPNG?maas=maas_adg_03C35D959069E81D700E52256331142E_afap_abs&ref_=aa_maas&tag=maas',
                                ca: 'https://www.amazon.ca/dp/B0FG89JPNG?maas=maas_adg_7627FE800FFD00EC34643DD0C697206D_afap_abs&ref_=aa_maas&tag=maas',
                            };
                            return linkAmazonMap[locale] || linkAmazonMap['us'];
                        })(),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687310784/EcoFlow%20STREAM%20(15).png',
                        color: '#2C2C2C',
                        //黑
                        productId: (() => {
                            const localMap: any = {
                                us: '15361644200009',
                                ca: '15126373794163',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                us: '54593884160073',
                                ca: '52731645034867',
                            };
                            return localMap[locale] || localMap['us'];
                        })(),
                        linkAmazon: (() => {
                            const linkAmazonMap: any = {
                                us: 'https://www.amazon.com/dp/B0FG89QZ2N?maas=maas_adg_5E3F358D29FDA715A4A92A62399C9AA8_afap_abs&ref_=aa_maas&tag=maas',
                                ca: 'https://www.amazon.ca/dp/B0FG89QZ2N?maas=maas_adg_88BBB3891981B2E7B3DE5FE32B1D00EA_afap_abs&ref_=aa_maas&tag=maas',
                            };
                            return linkAmazonMap[locale] || linkAmazonMap['us'];
                        })(),
                    },
                ],
            },
        ];
    }
    if (IS_PH) {
        data = [
            {
                img: '',
                imgs: [
                    'https://websiteoss.ecoflow.com/upload/image/1748687311715/EcoFlow%20STREAM%20(5).png',
                    'https://websiteoss.ecoflow.com/upload/image/1748687312637/EcoFlow%20STREAM%20(4).png',
                    'https://websiteoss.ecoflow.com/upload/image/1748687311510/EcoFlow%20STREAM%20(3).png',
                ],
                title: t('C_item1_title'),
                index: 0,

                price: 0,
                compareAtPrice: 0,
                inventoryQuantity: 0,

                isNotifyMe: true,
                isComingSoon: 'ComingSoon',
                info: [
                    { title: t('C_item1_info3_title'), desc: t('C_item1_info3_desc') },
                    { title: t('C_item1_info1_title'), desc: t('C_item1_info1_desc') },
                    { title: t('C_item1_info2_title'), desc: t('C_item1_info2_desc') },
                ],
                childrenColor: ['#959DA5', '#2C2C2C', '#50665F'],
                children: [
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687311715/EcoFlow%20STREAM%20(5).png',
                        color: '#959DA5',
                        //    银色
                        productId: (() => {
                            const localMap: any = {
                                ph: '10360152457526',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                ph: '53096507048246',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        linkBuy: (() => {
                            const linkBuyMap: any = {
                                ph: `https://${locale}.ecoflow.com/products/ecoflow-rapid-power-bank-25000mah-170w?variant=53096507048246`,
                            };
                            return linkBuyMap[locale] || undefined;
                        })(),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687312637/EcoFlow%20STREAM%20(4).png',
                        color: '#2C2C2C',
                        //黑
                        productId: (() => {
                            const localMap: any = {
                                ph: '10360152457526',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                ph: '53096507015478',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        linkBuy: (() => {
                            const linkBuyMap: any = {
                                ph: `https://${locale}.ecoflow.com/products/ecoflow-rapid-power-bank-25000mah-170w?variant=53096507015478`,
                            };
                            return linkBuyMap[locale] || undefined;
                        })(),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687311510/EcoFlow%20STREAM%20(3).png',
                        color: '#2C2C2C',
                        //绿
                        productId: (() => {
                            const localMap: any = {
                                ph: '10360152457526',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                ph: '53096507081014',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        linkBuy: (() => {
                            const linkBuyMap: any = {
                                ph: `https://${locale}.ecoflow.com/products/ecoflow-rapid-power-bank-25000mah-170w?variant=53096507081014`,
                            };
                            return linkBuyMap[locale] || undefined;
                        })(),
                    },
                ],
            },
            {
                img: '',
                imgs: [
                    'https://websiteoss.ecoflow.com/upload/image/1748687311939/EcoFlow%20STREAM%20(9).png',
                    'https://websiteoss.ecoflow.com/upload/image/1748687312283/EcoFlow%20STREAM%20(10).png',
                ],
                title: t('C_item2_title'),
                index: 1,

                price: 0,
                compareAtPrice: 0,
                inventoryQuantity: 0,

                info: [
                    { title: t('C_item2_info1_title'), desc: t('C_item2_info1_desc') },
                    { title: t('C_item2_info3_title'), desc: t('C_item2_info3_desc') },
                    { title: t('C_item2_info2_title'), desc: t('C_item2_info2_desc') },
                ],
                childrenColor: ['#ffffff', '#2C2C2C'],
                children: [
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687311939/EcoFlow%20STREAM%20(9).png',
                        lBtn: t('buy2'),
                        color: '#ffffff',
                        //白
                        productId: (() => {
                            const localMap: any = {
                                ph: '10322682544438',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                ph: '53048001265974',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        linkBuy: (() => {
                            const linkBuyMap: any = {
                                ph: `https://${locale}.ecoflow.com/products/ecoflow-rapid-charger-45w-retractable-cable-gan?variant=53048001265974`,
                            };
                            return linkBuyMap[locale] || undefined;
                        })(),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687312283/EcoFlow%20STREAM%20(10).png',
                        color: '#2C2C2C',
                        //黑
                        productId: (() => {
                            const localMap: any = {
                                ph: '10322682544438',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                ph: '53048001298742',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        linkBuy: (() => {
                            const linkBuyMap: any = {
                                ph: `https://${locale}.ecoflow.com/products/ecoflow-rapid-charger-45w-retractable-cable-gan?variant=53048001298742`,
                            };
                            return linkBuyMap[locale] || undefined;
                        })(),
                    },
                ],
            },
            {
                img: '',
                imgs: [
                    'https://websiteoss.ecoflow.com/upload/image/1748687310408/EcoFlow%20STREAM%20(14).png',
                    'https://websiteoss.ecoflow.com/upload/image/1748687310784/EcoFlow%20STREAM%20(15).png',
                ],
                title: t('C_item3_title'),
                index: 2,

                price: 0,
                compareAtPrice: 0,
                inventoryQuantity: 0,
                info: [
                    { title: t('C_item3_info1_title'), desc: t('C_item3_info1_desc') },
                    { title: t('C_item3_info2_title'), desc: t('C_item3_info2_desc') },
                    { title: t('C_item3_info3_title'), desc: t('C_item3_info3_desc') },
                ],
                childrenColor: ['#ffffff', '#2C2C2C'],
                children: [
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687310408/EcoFlow%20STREAM%20(14).png',
                        color: '#ffffff',
                        //白
                        productId: (() => {
                            const localMap: any = {
                                ph: '10322683986230',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                ph: '53048002576694',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        linkBuy: (() => {
                            const linkBuyMap: any = {
                                ph: `https://${locale}.ecoflow.com/products/ecoflow-rapid-charger-65w-retractable-cable-gan?variant=53048002576694`,
                            };
                            return linkBuyMap[locale] || undefined;
                        })(),
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1748687310784/EcoFlow%20STREAM%20(15).png',
                        color: '#2C2C2C',
                        //黑
                        productId: (() => {
                            const localMap: any = {
                                ph: '10322683986230',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        variantId: (() => {
                            const localMap: any = {
                                ph: '53048002609462',
                            };
                            return localMap[locale] || localMap['ph'];
                        })(),
                        linkBuy: (() => {
                            const linkBuyMap: any = {
                                ph: `https://${locale}.ecoflow.com/products/ecoflow-rapid-charger-65w-retractable-cable-gan?variant=53048002609462`,
                            };
                            return linkBuyMap[locale] || undefined;
                        })(),
                    },
                ],
            },
        ];
    }
    const [items, setItems] = useState<ItemType[]>(data);
    const [activeItem, setActiveItem] = useState<ItemType>(items[0]);

    const [groups, setGroups] = useState<ItemType[][]>([]);
    const [groupsH5, setGroupsH5] = useState<ItemType[][]>([]);
    const [activeId, setActiveId] = useState<number>(items[0]?.index);
    const [selectedColorIndices, setSelectedColorIndices] = useState([0, 0, 0, 0, 0]);
    const { pageStatus } = useProductStore();

    const handleHover = (item: ItemType, m: number) => {
        if (item.index !== activeItem.index) {
            const index = item.index;
            setActiveItem(item);
            // swiperInstance?.slideTo(selectedColorIndices[index], 0, false);
            setActiveId(index);
        }
    };
    const productList = useProductInfo(data, { productTitle: 'title' }) || [];
    useEffect(() => {
        // 其他模块也需要使用到产品信息，所以这里需要更新
        dispatch({
            type: 'changeProductInfo',
            payload: productList,
        });
    }, [productList, dispatch]);
    useEffect(() => {
        const newItems = JSON.parse(JSON.stringify(productList));
        setItems(newItems);
        if (typeof window !== 'undefined' && productList) {
            setActiveItem(newItems[0]);
            if (IS_EU) {
                setGroupsH5([newItems.slice(0, 2)]);
                setGroups([newItems.slice(0, 2)]);
                return;
            }
            if (IS_US) {
                setGroupsH5([newItems.slice(0, 2), newItems.slice(2, 4)]);
                setGroups([newItems.slice(0, 2), newItems.slice(2, 4)]);
                return;
            }
            if (IS_PH) {
                setGroupsH5([newItems.slice(0, 3)]);
                setGroups([newItems.slice(0, 3)]);
                return;
            }
            setGroupsH5([newItems.slice(0, 3), newItems.slice(3, 5)]);
            setGroups([newItems.slice(0, 3), newItems.slice(3, 5)]);
            return;
        }
    }, [productList]);
    // 颜色切换

    const handleColorSelect = (e: MouseEvent<HTMLSpanElement>, productIdx: number, colorIdx: number) => {
        e.stopPropagation();
        const newColorSelections = [...selectedColorIndices];
        newColorSelections[productIdx] = colorIdx;
        setSelectedColorIndices(newColorSelections);
        const width = document.documentElement.clientWidth;
        if (width <= 1024) return;
        swiperInstance?.slideTo(colorIdx, 0, false);
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: t('title'),
            button_name: `${items[productIdx]?.title}_${items[productIdx]?.childrenColor?.[colorIdx]}`,
        });
    };
    const linkGtm = (type: string, item: any, cls: string) => {
        if (type === 'Buy Now') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'checkout',
                list_name: t('title'),
                button_name: `${t('l_btn')}_${items[item.index]?.title}`,
                __btn_id1: `rapid-C ${cls}`,
                __btn_id2: cls?.startsWith('.amazon-') ? item.linkAmazon : item.linkBuy,
                __btn_type: 'href',
            });
        } else if (type === 'buy') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: `${t('l_btn')}_${items[item.index]?.title}`,
                position: t('title'),
                __btn_id1: `rapid-C ${cls}`,
                __btn_id2: cls?.startsWith('.amazon-') ? item.linkAmazon : item.linkBuy,
                __btn_type: 'href',
            });
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy_on_amazon',
                list_name: t('title'),
                product_name: items[item.index]?.title,
                button_name: t('r_btn'),
                __btn_id1: `rapid-C ${cls}`,
                __btn_id2: cls?.startsWith('.amazon-') ? item.linkAmazon : item.linkBuy,
                __btn_type: 'href',
            });
        }
    };
    // 监听当前产品变化,切换产品动画
    const animRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (animRef.current) {
            // 1. 先删除动画 class（重置）
            animRef.current.classList.remove('fade-in');
            // 2. 触发重绘，让浏览器认为 class 被真正移除了
            void animRef.current?.offsetWidth;
            // 3. 重新加上动画 class
            animRef.current?.classList.add('fade-in');
        }
    }, [activeId, selectedColorIndices]);

    // 埋点
    type GTM_Type = 'Left' | 'Right' | 'amazon';
    const handleGTM = (type: GTM_Type) => {
        let obj = {};
        switch (type) {
            case 'Right':
            case 'Left':
                obj = {
                    event: 'uaEvent',
                    event_name: 'product_detail_page',
                    list_name: t('title'),
                    button_name: `${type} switch`,
                };
                break;
            case 'amazon':
                obj = {};
                break;
        }
        gtm.push(obj);
    };
    return (
        <div id="rapid-C" className={`rapid-C ${css.section} GtmModuleData-section`} data-section-id={'rapid-C'}>
            <EcoSpace />
            <EfSection title={locale === 'jp' ? (!isMobile ? t('title') : t('title_H5')) : t('title')} />
            <div className="pc">
                <div className="swiper-container">
                    <Swiper
                        className="box-swiper"
                        slidesPerView={'auto'}
                        spaceBetween={24}
                        speed={0}
                        navigation={{
                            nextEl: '.eco-swiper-button-next',
                            prevEl: '.eco-swiper-button-prev',
                        }}
                        key={activeId}
                        modules={[Navigation]}
                        onTransitionStart={(swiper) => {
                            setSelectedColorIndices((state) => {
                                const newState = [...state];
                                newState[activeId] = swiper.activeIndex;
                                return newState;
                            });
                        }}
                        onSwiper={(swiper) => {
                            setSwiperInstance(swiper);
                        }}
                        initialSlide={selectedColorIndices[activeId]}
                    >
                        {activeItem?.imgs?.map((i: any, index: number) => {
                            return (
                                <SwiperSlide key={index} className={`box-item`}>
                                    <div className="inner">
                                        <div className="img-box">
                                            <EcoImg pc={i} />
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                        <div className="eco-swiper-control">
                            <div className="eco-swiper-navigation">
                                <div className="eco-swiper-button-prev" onClick={() => handleGTM('Left')}>
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                                <div className="eco-swiper-button-next" onClick={() => handleGTM('Right')}>
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                            </div>
                        </div>
                    </Swiper>
                    <div className="swiper-info" ref={animRef}>
                        {activeItem.info.map((item, index) => {
                            console.log('item.desc', item);
                            return (
                                <div className={`info-item info-item-${index + 1}`}>
                                    <div className="item-value">{item.title}</div>
                                    <div className="item-name">{item.desc}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <ul className="groups">
                    {groups.map((group: ItemType[], k: number) => {
                        return (
                            <li className="group" key={k} style={{ width: `calc(100% / ${items?.length} * ${group.length})` }}>
                                <div className={`group-head${group?.find((item: ItemType) => item.index === activeItem.index) ? ' active' : ''}`}>
                                    <p className="group-head-title">{t(`C_series_title_${k + 1}`)}</p>
                                    <p className={`group-head-line`}></p>
                                </div>
                                <ul className="group-items">
                                    {group.map((item: ItemType, m: number) => {
                                        const present: ItemType = item.children?.[selectedColorIndices[item.index]] || {};
                                        // const usLinkBuy = `https://${locale}.ecoflow.com/cart/${present.variantId}:1?channel=buy_button`;
                                        console.log('present.linkBuy', present.linkBuy);
                                        return (
                                            <li
                                                className={`group-item${activeItem.index === item.index ? ' active' : ''} g-i-${k}-${m} GtmModuleData-btn-href`}
                                                key={`${k}_${m}`}
                                                style={{ width: `calc(100% / ${group.length})` }}
                                                onMouseEnter={() => handleHover(item, m)}
                                                onClick={(e) => {
                                                    if (item.isNotifyMe) {
                                                        return;
                                                    }
                                                    if (locale === 'ph') {
                                                        linkGtm('buy', item, `.g-i-${k}-${m}`);
                                                        window.open(present.linkBuy, '_blank');
                                                        return;
                                                    }
                                                    linkGtm('buy', item, `.g-i-${k}-${m}`);
                                                    window.open(item.linkBuy, '_blank'); //点击按钮及颜色选择以外区域 新窗口打开链接
                                                }}
                                            >
                                                {/* <EcoLink className={`group-item-link`} href={item.linkMore}> */}
                                                <div className="group-item-img">
                                                    <EcoImg pc={present?.pc} />
                                                </div>
                                                <ul className={`group-item-colors colors-${item.index}`}>
                                                    {item.childrenColor &&
                                                        item.childrenColor.length > 1 &&
                                                        item.childrenColor?.map((color: any, m: number) => {
                                                            return (
                                                                <li className={`color${selectedColorIndices[item.index] === m ? ' active' : ''}`} key={`_${m}`}>
                                                                    <span className="outer" onClick={(e) => handleColorSelect(e, item.index, m)}>
                                                                        <span className="inner" style={{ backgroundColor: color }}></span>
                                                                    </span>
                                                                </li>
                                                            );
                                                        })}
                                                </ul>
                                                <p className="group-item-coming">{item.isComingSoon}</p>
                                                <div className="group-item-info">
                                                    {present.compareAtPrice !== present.price && (
                                                        <div className={`group-item-info-label `}>
                                                            {present?.compareAtPrice || 0 === present?.price || 0
                                                                ? ''
                                                                : Math.round(((present.compareAtPrice - present.price) / present.compareAtPrice) * 100) +
                                                                  '%' +
                                                                  t('C_off')}
                                                        </div>
                                                    )}
                                                    <p className="group-item-info-title">{item.title}</p>
                                                    <div className="group-item-info-bot">
                                                        {isPad ? (
                                                            <>
                                                                <div className="group-item-info-price">
                                                                    <p className="group-item-info-price-price">{FormatMoneyLocal(present?.price, locale)}</p>
                                                                    {present.compareAtPrice !== present.price && (
                                                                        <p className="group-item-info-price-compare">
                                                                            {FormatMoneyLocal(present.compareAtPrice, locale)}
                                                                        </p>
                                                                    )}
                                                                </div>
                                                                {(present.linkBuy || item.linkBuy) && !present.lDisabled && !item.isNotifyMe && (
                                                                    <EcoLink
                                                                        stopPropagation
                                                                        className={`group-item-info-btn GtmModuleData-btn-href buy-${k}-${m}`}
                                                                        href={present?.linkBuy || item.linkBuy}
                                                                        target="_blank"
                                                                        onClick={() => linkGtm('Buy Now', item, `.buy-${k}-${m}`)}
                                                                    >
                                                                        {locale === 'jp' || IS_US || IS_PH
                                                                            ? t('l_btn')
                                                                            : pageStatus === IPageStatus.statusA
                                                                            ? t('Prepare_btn')
                                                                            : t('l_btn')}
                                                                    </EcoLink>
                                                                )}
                                                                {item.isNotifyMe && (
                                                                    <EcoLink
                                                                        stopPropagation
                                                                        className={`group-item-info-btn notifyMe GtmModuleData-btn-href buy-${k}-${m}`}
                                                                        // href={present.linkBuy || item.linkBuy}
                                                                        target="_blank"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setShowNotifyMeModal(true);
                                                                            gtm.push({
                                                                                __btn_id1: `group-item-info-bot .buy-${k}-${m}`,
                                                                                __btn_id2: t('notify-me'),
                                                                                __btn_type: 'text',
                                                                            });
                                                                        }}
                                                                    >
                                                                        {t('notify-me')}
                                                                    </EcoLink>
                                                                )}
                                                                {present?.linkAmazon && !present.lDisabled && (
                                                                    <EcoLink
                                                                        stopPropagation
                                                                        className={`group-item-info-btn GtmModuleData-btn-href amazon amazon-${k}-${m}`}
                                                                        href={present.linkAmazon}
                                                                        target="_blank"
                                                                        onClick={() => linkGtm('Amazon', item, `.amazon-${k}-${m}`)}
                                                                    >
                                                                        {Amazon}
                                                                        {t('r_btn')}
                                                                    </EcoLink>
                                                                )}
                                                                {present.lDisabled && (
                                                                    <EcoLink stopPropagation className={`group-item-info-btn disabled`}>
                                                                        {present.DisabledText}
                                                                    </EcoLink>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                {activeItem.index !== item.index && (
                                                                    <div className="group-item-info-price">
                                                                        <p className="group-item-info-price-price">
                                                                            {FormatMoneyLocal(present?.price, locale)}
                                                                        </p>
                                                                        {present.compareAtPrice !== present.price && (
                                                                            <p className="group-item-info-price-compare">
                                                                                {FormatMoneyLocal(present.compareAtPrice, locale)}
                                                                            </p>
                                                                        )}
                                                                    </div>
                                                                )}
                                                                {activeItem.index === item.index &&
                                                                    (present.linkBuy || item.linkBuy) &&
                                                                    !present.lDisabled &&
                                                                    !item.isNotifyMe && (
                                                                        <EcoLink
                                                                            stopPropagation
                                                                            className={`group-item-info-btn GtmModuleData-btn-href buy-${k}-${m}`}
                                                                            href={present.linkBuy || item.linkBuy}
                                                                            target="_blank"
                                                                            onClick={() => linkGtm('Buy Now', item, `.buy-${k}-${m}`)}
                                                                        >
                                                                            {locale === 'jp' || IS_US || IS_PH
                                                                                ? t('l_btn')
                                                                                : pageStatus === IPageStatus.statusA
                                                                                ? t('Prepare_btn')
                                                                                : t('l_btn')}
                                                                        </EcoLink>
                                                                    )}
                                                                {activeItem.index === item.index && item.isNotifyMe && (
                                                                    <EcoLink
                                                                        stopPropagation
                                                                        className={`group-item-info-btn notifyMe GtmModuleData-btn-href buy-${k}-${m}`}
                                                                        // href={present.linkBuy || item.linkBuy}
                                                                        target="_blank"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setShowNotifyMeModal(true);
                                                                            gtm.push({
                                                                                __btn_id1: `group-item-info-bot .buy-${k}-${m}`,
                                                                                __btn_id2: t('notify-me'),
                                                                                __btn_type: 'text',
                                                                            });
                                                                        }}
                                                                    >
                                                                        {t('notify-me')}
                                                                    </EcoLink>
                                                                )}
                                                                {activeItem.index === item.index && present?.linkAmazon && !present.lDisabled && (
                                                                    <EcoLink
                                                                        stopPropagation
                                                                        className={`group-item-info-btn amazon GtmModuleData-btn-href amazon-${k}-${m}`}
                                                                        href={present.linkAmazon}
                                                                        target="_blank"
                                                                        onClick={() => linkGtm('Amazon', item, `.amazon-${k}-${m}`)}
                                                                    >
                                                                        {Amazon}
                                                                        {t('r_btn')}
                                                                    </EcoLink>
                                                                )}
                                                                {activeItem.index === item.index && present.lDisabled && (
                                                                    <EcoLink className={`group-item-info-btn disabled`}>{present.DisabledText}</EcoLink>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                {/* </EcoLink> */}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <ul className="h5 rows">
                {groupsH5.map((group: ItemType[], k: number) => (
                    <li className={`row row${k + 1}`} key={k}>
                        <div className="row-header">
                            <p className="row-header-title">{k === 0 ? t(`C_series_title_${k + 1}`) : `${t(`C_series_title_${k + 1}`)}`}</p>
                            <p className="row-header-line"></p>
                        </div>
                        <Swiper className="row-swiper" slidesPerView={'auto'} initialSlide={0} spaceBetween={12}>
                            {group.map((item: ItemType, m: number) => {
                                const present: ItemType = item.children?.[selectedColorIndices[item.index]] || {};
                                return (
                                    <SwiperSlide
                                        className={`item item-${k}-${m} GtmModuleData-btn-href`}
                                        key={`${k}_${m}`}
                                        onClick={() => {
                                            if (item.isNotifyMe) {
                                                return;
                                            }
                                            if (locale === 'ph') {
                                                linkGtm('buy', item, `.g-i-${k}-${m}`);
                                                window.open(present.linkBuy, '_blank');
                                                return;
                                            }
                                            linkGtm('buy', item, `.item-${k}-${m}`);
                                            window.open(item.linkBuy, '_blank'); //点击按钮及颜色选择以外区域 新窗口打开链接
                                        }}
                                    >
                                        <EcoImg className="item-img" pc={present?.pc} />
                                        <ul className="group-item-colors">
                                            {item.childrenColor &&
                                                item.childrenColor.length > 1 &&
                                                item.childrenColor?.map((color: any, m: number) => {
                                                    return (
                                                        <li className={`color${selectedColorIndices[item.index] === m ? ' active' : ''}`} key={`_${m}`}>
                                                            <span className="outer" onClick={(e) => handleColorSelect(e, item.index, m)}>
                                                                <span className="inner" style={{ backgroundColor: color }}></span>
                                                            </span>
                                                        </li>
                                                    );
                                                })}
                                        </ul>
                                        <p className="group-item-coming">{item.isComingSoon}</p>
                                        <p className="item-title">{item.title}</p>
                                        <div className="item-price">
                                            <p className="item-price-price">{FormatMoneyLocal(present.price, locale)}</p>
                                            <p className="item-price-compare">{FormatMoneyLocal(present.compareAtPrice, locale)}</p>
                                        </div>
                                        <div className="item-btns">
                                            {(present.linkBuy || item.linkBuy) && !present.lDisabled && !item.isNotifyMe && (
                                                <EcoLink
                                                    stopPropagation
                                                    className={`item-btn GtmModuleData-btn-href buy-${k}-${m}`}
                                                    href={`${item.linkBuy}`}
                                                    target="_blank"
                                                    onClick={() => linkGtm('Buy Now', item, `.buy-${k}-${m}`)}
                                                >
                                                    {locale === 'jp' || IS_US || IS_PH
                                                        ? t('l_btn')
                                                        : pageStatus === IPageStatus.statusA
                                                        ? t('Prepare_btn')
                                                        : t('l_btn')}
                                                </EcoLink>
                                            )}
                                            {item.isNotifyMe && (
                                                <EcoLink
                                                    stopPropagation
                                                    className={`item-btn notifyMe GtmModuleData-btn-href buy-${k}-${m}`}
                                                    // href={`${item.linkBuy}`}
                                                    target="_blank"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setShowNotifyMeModal(true);
                                                        gtm.push({
                                                            __btn_id1: `group-item-info-bot .buy-${k}-${m}`,
                                                            __btn_id2: t('notify-me'),
                                                            __btn_type: 'text',
                                                        });
                                                    }}
                                                >
                                                    {t('notify-me')}
                                                </EcoLink>
                                            )}
                                            {present?.linkAmazon && !present.lDisabled && (
                                                <EcoLink
                                                    className={`item-btn amazon amazon-${k}-${m} GtmModuleData-btn-href`}
                                                    href={present.linkAmazon}
                                                    stopPropagation
                                                    target="_blank"
                                                    onClick={() => linkGtm('Amazon', item, `.amazon-${k}-${m}`)}
                                                >
                                                    {Amazon}
                                                    {t('r_btn')}
                                                </EcoLink>
                                            )}
                                            {present.lDisabled && (
                                                <EcoLink stopPropagation className={`item-btn disabled`}>
                                                    {present.DisabledText}
                                                </EcoLink>
                                            )}
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </li>
                ))}
            </ul>
            {t('C_tip') && <p className="tip">{t('C_tip')}</p>}
            <Dialog open={showNotifyMeModal} onClose={() => setShowNotifyMeModal(false)} />
        </div>
    );
};

export default C;
